import React from "react";
import "./CurrentCard.scss";
import {useHistory} from "react-router-dom";
import {
    convertPayStatusCode, convertPayStatusStyle,
    convertStatusCode,
    convertStatusStyle,
    ConvertToJalaliSplitedString
} from "../../../Services";
import {orderPickerAcceptOrder_api} from "../PackManService";

function CurrentCard({item}) {

    const history = useHistory()



     const convertStack = (code,pStatus) => {
        let result =""
        switch (code) {
            case 1:
                result  =  "انتخاب سفارش"
                break;
            case 2:
                result  =  "انتخاب سفارش"
                break;
            case 3:
                // result  =  "نهایی شده توسط مشتری"
                result  =  "انتخاب سفارش"
                break;
            case 5:
                result  =  "رد شده توسط صندوقدار"
                break;
            case 13:
                result  =  "آماده ارسال"
                break;
            case 20:
                result  =  "در حال ارسال"
                break;
            case 25:
                result  =  "تحویل شده"
                break;
            case 9:
                result  =  "شروع جمع آوری"
                break;
            case 10:
                result  =  "جمع آوری شده"
                break;
            case 15:
                result  =  "تحویل پیک شد"
                break;
            case 30:
                result  =  "توسط مشتری کنسل شد"
                break;

        }

        if(pStatus===1)
            result  =  "در انتظار پرداخت"

        return result;

    }

    const AcceptOrder = async (order) =>{
        if(order.status===1 || order.status===2){
            try {
                const response = await orderPickerAcceptOrder_api(order.uid)
                history.push(`/pack-man/${order.uid}`)
            }catch (e) {
                console.log(e)
            }
        }
        else {
            history.push(`/pack-man/${order.uid}`)
        }
    }

    const checkActiveList = (status,pay)=>{
        let result = ""
        switch(status){
            case 1:
                result =  true
                break
            case 2:
                result =  true
                break
            case 3:
                result =  true
                break
            default:
                result =  false
        }

        if(pay=== 1)
            result =false

        return result
    }

    return(
        <div className="current-card-container">
            <div
                onClick={()=>{
                    if(item.pay_status===1){

                    }else{
                        AcceptOrder(item)
                    }
                }}
                className={checkActiveList(item.status,item.pay_status)?"current-card-btn-active":"current-card-btn-deActive"}>
                <span>{convertStack(item.status,item.pay_status)}</span>
            </div>
            <div className="current-card-info">
                <span className="name">{item?.user?.full_name}</span>
                <span style={{color:convertStatusStyle(item?.status)}} className="status">{convertStatusCode(item.status)}</span>
                <span style={{color:convertPayStatusStyle(item?.pay_status)}}  className="status">{convertPayStatusCode(item.pay_status)}</span>
                <span className="time">{ConvertToJalaliSplitedString(item.from_shipping_time)}</span>
            </div>
        </div>
    )

}

export {CurrentCard}
